<form [formGroup]="form" (submit)="onSubmit()">
  <h2>Serious Concern Alert</h2>
  <p>
    <mat-slide-toggle formControlName="severeConcernWarning">
      Display serious concern alert in app
    </mat-slide-toggle>
  </p>

  <p>
    <mat-form-field class="large">
      <textarea
        matInput
        rows="6"
        formControlName="severeConcernMessage"
        placeholder="Message for Staff"
      ></textarea>
    </mat-form-field>
  </p>

  <h2>Comment Moderation</h2>
  <p>Comments require approval before being shown to other users</p>
  <mat-slide-toggle
    formControlName="commentsRequireApproval"
  ></mat-slide-toggle>

  <h2>Wellbeing Check Sharing</h2>
  <p>Display wellbeing checks to Family Representatives</p>
  <mat-slide-toggle [formControl]="shareCheckIns"></mat-slide-toggle>

  <h2>Family Posting Content</h2>
  <p>
    Whether to allow family to post photos, videos, and notes to CareApp. Family
    will also be able to post Wellbeing Checks if they are enabled for family
    above.
  </p>
  <mat-slide-toggle formControlName="familyCanPostContent"></mat-slide-toggle>

  <h2>Inviting to Customer Communities</h2>
  <p>
    Choose the roles that are allowed to invite new users to a customer’s
    community
  </p>

  <mat-checkbox [checked]="true" [disabled]="true">
    {{ "roles.plural." + ORGANISATION_ADMIN_ROLE | translate }}
  </mat-checkbox>

  <div *ngFor="let role of userRoles">
    <mat-checkbox
      [disabled]="form?.controls?.inviteToCustomerRoles?.disabled"
      [id]="'inviteToCustomerRole-' + role"
      [checked]="!!form.value.inviteToCustomerRoles?.includes(role)"
      (change)="updateInviteToCustomerRoles(role, $event.checked)"
    >
      {{ "roles.plural." + role | translate }}
    </mat-checkbox>
  </div>

  <h2>Saving images</h2>
  <p>Choose the roles that are allowed to save images</p>

  <mat-checkbox [disabled]="true" [checked]="true">
    {{ "roles.plural." + ORGANISATION_ADMIN_ROLE | translate }}
  </mat-checkbox>

  <div *ngFor="let role of userRoles">
    <mat-checkbox
      [disabled]="form?.controls?.saveImageRoles?.disabled"
      [id]="'saveImageRole-' + role"
      [checked]="!!form.value.saveImageRoles?.includes(role)"
      (change)="updateSaveImageRoles(role, $event.checked)"
    >
      {{ "roles.plural." + role | translate }}
    </mat-checkbox>
  </div>

  <h2>Share to apps</h2>
  <p>
    Choose the roles that are allowed to create public links and sharing to
    apps.
  </p>
  <p>
    <mat-checkbox [disabled]="true" [checked]="true">
      {{ "roles.plural." + ORGANISATION_ADMIN_ROLE | translate }}
    </mat-checkbox>
  </p>

  <div *ngFor="let role of userRoles">
    <mat-checkbox
      [disabled]="form?.controls?.shareToPublicRoles?.disabled"
      [id]="'shareToPublicRole-' + role"
      [checked]="!!form.value.shareToPublicRoles?.includes(role)"
      (change)="updateShareToPublicRoles(role, $event.checked)"
    >
      {{ "roles.plural." + role | translate }}
    </mat-checkbox>
  </div>

  <p>
    <button
      mat-flat-button
      type="submit"
      color="primary"
      [disabled]="form.disabled"
    >
      Save Preferences
    </button>
  </p>
</form>
